import ExcelJS from 'exceljs/dist/exceljs.bare';

import { CellFormat, TabConfig } from '../excel.service.model';
import { Product } from '../../../product-center-table-wrapper/product-center-table-wrapper.model';
import { Constants } from '../excel-service.constants';
import { Constants as ProductCenterTableWrapperConstants } from '../../../product-center-table-wrapper/product-center-table-wrapper.constants';
import { formatDate } from '../excel-service.utils';
import { i18nService } from '../../../../common/i18n/i18n';

/**
 * Returns the configuration object for the performance tab.
 * @returns {TabConfig} The configuration object for the performance tab.
 */
export async function getPerformanceConfig(
  language: string,
): Promise<TabConfig> {
  if (!i18nService.isI18nLoadedForLanguage(language)) {
    await new Promise((resolve) => {
      i18nService.loadi18nForLanguage(language, resolve);
    });
  }

  const localize = i18nService.getFixedT(language, null, null);

  return {
    worksheetName: localize(
      ProductCenterTableWrapperConstants.TRANSLATION_KEYS.TABS.PERFORMANCE,
    ),
    fileName: `${localize(Constants.TRANSLATION_KEYS.FILE_NAME.PERFORMANCE)}.${Constants.EXCEL_FILE_EXTENSION}`,
    headers: [
      localize(Constants.TRANSLATION_KEYS.PRODUCT_RANGE),
      localize(Constants.TRANSLATION_KEYS.PRODUCT_NAME),
      localize(Constants.TRANSLATION_KEYS.CLASS),
      localize(Constants.TRANSLATION_KEYS.APIR),
      localize(Constants.TRANSLATION_KEYS.PERFORMANCE.INCEPTION_DATE),
      localize(Constants.TRANSLATION_KEYS.PERFORMANCE.YTD),
      localize(Constants.TRANSLATION_KEYS.PERFORMANCE.ONE_YEAR),
      localize(Constants.TRANSLATION_KEYS.PERFORMANCE.THREE_YEAR),
      localize(Constants.TRANSLATION_KEYS.PERFORMANCE.FIVE_YEAR),
      localize(Constants.TRANSLATION_KEYS.PERFORMANCE.TEN_YEAR),
      localize(Constants.TRANSLATION_KEYS.PERFORMANCE.SINCE_INCEPTION),
    ],
    columnWidths: Object.values(Constants.COLUMN_WIDTHS.PERFORMANCE),
    getRowData: (product: Product) => [
      product.productName.vehicleTypeName,
      product.productName.fundName,
      product.productName.shareClass,
      product.productName.apir,
      formatDate(product.performance?.inceptionDate),
      product.performance?.fundReturns?.yearToDate?.[0]?.value,
      product.performance?.fundReturns?.oneYear?.[0]?.value,
      product.performance?.fundReturns?.threeYears?.[0]?.value,
      product.performance?.fundReturns?.fiveYears?.[0]?.value,
      product.performance?.fundReturns?.tenYears?.[0]?.value,
      product.performance?.fundReturns?.sinceInception?.[0]?.value,
    ],
    cellFormatters: [
      { index: 5, format: CellFormat.NUMBER },
      { index: 6, format: CellFormat.NUMBER },
      { index: 7, format: CellFormat.NUMBER },
      { index: 8, format: CellFormat.NUMBER },
      { index: 9, format: CellFormat.NUMBER },
      { index: 10, format: CellFormat.NUMBER },
    ],
    specialFormatting: (row: ExcelJS.Row) => {
      const alignment =
        row.getCell(5).value === Constants.HYPHEN
          ? Constants.ALIGNMENT.HORIZONTAL.LEFT
          : Constants.ALIGNMENT.HORIZONTAL.RIGHT;
      row.getCell(5).alignment = { horizontal: alignment };
    },
    renderFooterDisclaimers: true,
  };
}
